import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LenisGate from "@/components/LenisGate";
import Home from "@/pages/Home";
import Campaign from "@/pages/Campaign";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import "@/App.css";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="grid min-h-screen place-items-center bg-[#FDFBF7] p-6 text-center">
          <div>
            <h1 className="font-display text-2xl font-extrabold text-[#261C14]">Ops! Algo deu errado.</h1>
            <button
              className="mt-4 rounded-full bg-[#FF6D47] px-6 py-3 font-extrabold text-white"
              onClick={() => window.location.reload()}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <LenisGate />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vaquinha/:slug" element={<Campaign />} />
          <Route path="/obrigado" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
